var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <button type=\"button\" data-role=\"submit\" class=\"btn btn-default\" disabled>"
    + alias4(((helper = (helper = helpers.submit_button || (depth0 != null ? depth0.submit_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"submit_button","hash":{},"data":data}) : helper)))
    + "</button>\n            <button type=\"button\" data-role=\"reset\" class=\"btn btn-default\" disabled>"
    + alias4(((helper = (helper = helpers.reset_button || (depth0 != null ? depth0.reset_button : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset_button","hash":{},"data":data}) : helper)))
    + "</button>\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div data-role=\"filter\"></div>\n\n\n\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.hideFooterButtons : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/tabs/filter.hbs
// module id = 72
// module chunks = 0